module.exports = __webpack_public_path__ + "img/1.09c4e783.png";